import React from 'react';
import Bodegas from '../components/Bodegas';
import Footer from '../components/Footer';
import Cart from '../components/Cart';

const BodegasPage = () => {
  return (
    <>
      <Bodegas />
      <Cart />
      <Footer />
    </>
  );
};

export default BodegasPage;
